import { Actions } from '../actionTypes/actionTypes';

export const showGlobalSpinner = (message?: string) => {
    return {
        type: Actions.SHOW_GLOBAL_SPINNER,
        payload: { message }
    };
};

export const hideGlobalSpinner = () => {
    return {
        type: Actions.HIDE_GLOBAL_SPINNER
    };
};
